import React from "react"
import { Dialog, FlatButton, SelectField, MenuItem } from "material-ui"
import strings from "../../localization/strings"
import { IOptionalBoolParameterValue } from "../../models"
import { checkPhaseFieldAvailable } from "../../helpers/punchHelper"
import accountStore from "../../stores/AccountStore"

interface IProps {
    useYesNoLabelparameterNames: string[]
    parameterNames: string[]
    editValue: IOptionalBoolParameterValue
    values: IOptionalBoolParameterValue[]
    handleChange(values: IOptionalBoolParameterValue[]): void
    handleClose(): void
}
interface IState {
    name: string
    value: boolean
}

export default class AddFilterTemplateOptionalBoolParameterDialog extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            name: props.editValue ? props.editValue.Name : "",
            value: props.editValue ? props.editValue.Value : null
        }
    }

    render() {
        const useYesNo = this.props.useYesNoLabelparameterNames && this.props.useYesNoLabelparameterNames.includes(this.state.name)
        return (
            <Dialog
                open
                title={<h2 style={{ color: "#616161" }}>{this.props.editValue ? strings.Edit_Filter_Parameter : strings.Add_Filter_Parameter}</h2>}
                titleStyle={{ fontWeight: "bold" }}
                actions={[
                    <FlatButton
                        label={strings.CANCEL}
                        secondary
                        onClick={this.props.handleClose}
                    />,
                    <FlatButton
                        label={this.props.editValue ? strings.Update : strings.Add}
                        primary
                        onClick={() => {
                            const value: IOptionalBoolParameterValue = { Name: this.state.name.trim(), Value: this.state.value }
                            const values = this.props.values
                            if (this.props.editValue) {
                                const indexOf = values.findIndex(i => i.Name === this.props.editValue.Name)
                                values[indexOf] = value
                            }
                            else {
                                values.push(value)
                            }
                            this.props.handleChange(values)
                            this.props.handleClose()
                        }}
                        disabled={!this.state.name.trim() || this.state.value === null}
                    />
                ]}
            >
                <div style={{ display: "flex" }}>
                    <p style={{ color: "#616161" }}>{strings.Add_Filter_Parameter_Text1}</p>
                    <SelectField
                        value={this.state.name}
                        onChange={(event, key, name) => this.setState({ name })}
                        style={{ width: 280, paddingLeft: 10 }}
                        disabled={this.props.editValue ? true : false}
                    >
                        {this.props.parameterNames
                            .filter(i => this.props.editValue ? i === this.props.editValue.Name : !this.props.values.map(e => e.Name).includes(i))
                            .map(i => {
                                const name = strings[i] === strings.RequirePhase ? checkPhaseFieldAvailable("singular") ? `Require ${accountStore.getCurrentAccountSettings().CustomFieldSettings.PhaseFieldLabels.SingularPhaseLabel}` : strings[i]:  strings[i]
                           return ( <MenuItem value={i} primaryText={name} key={i} />)
                        })
                        }
                    </SelectField>
                    <p style={{ color: "#616161", paddingLeft: 15 }}>{strings.Add_Filter_Parameter_Text2}</p>
                    <SelectField
                        value={this.state.value}
                        onChange={(event, key, value) => this.setState({ value })}
                        style={{ width: 100, paddingLeft: 10 }}
                        disabled={!this.state.name.trim()}
                    >
                        <MenuItem value={true} primaryText={useYesNo ? strings.Yes : strings.ON} />
                        <MenuItem value={false} primaryText={useYesNo ? strings.No : strings.OFF} />
                    </SelectField>
                </div>
            </Dialog>
        )
    }
}
